import { Injectable } from '@angular/core';

export abstract class LocalStorage {
	abstract readonly length: number;
	abstract clear(): void;
	abstract getItem(key: string): string | null;
	abstract key(index: number): string | null;
	abstract removeItem(key: string): void;
	abstract setItem(key: string, data: string): void;
}

@Injectable()
export class LocalStorageNode implements LocalStorage {
	readonly length: number = 0;
	clear(): void { }
	getItem(key: string): string | null { return null; }
	key(index: number): string | null { return null; }
	removeItem(key: string): void { }
	setItem(key: string, data: string): void { }
}

@Injectable()
export class LocalStorageBrowser implements LocalStorage {
	get length(): number { return localStorage.length; }
	clear(): void { localStorage.clear(); }
	getItem(key: string): string | null { return localStorage.getItem(key); }
	key(index: number): string | null { return localStorage.key(index); }
	removeItem(key: string): void { localStorage.removeItem(key); }
	setItem(key: string, data: string): void { localStorage.setItem(key, data); }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/core/localstorage.ts